import type { TranslateDictionary } from './en.js';

export const Ar: TranslateDictionary = {
  'Start airplay': 'بدء AirPlay',
  'Stop airplay': 'إيقاف AirPlay',
  Audio: 'صوت',
  Captions: 'الترجمة النصية',
  'Enable captions': 'تفعيل الترجمة النصية',
  'Disable captions': 'تعطيل الترجمة النصية',
  'Start casting': 'بدء البث',
  'Stop casting': 'إيقاف البث',
  'Casting to {device}': 'جارٍ الإرسال إلى {device}',
  'Enter fullscreen mode': 'دخول الشاشة الكاملة',
  'Exit fullscreen mode': 'الخروج من الشاشة الكاملة',
  Mute: 'كتم الصوت',
  Unmute: 'إلغاء كتم الصوت',
  'Enter picture in picture mode': 'دخول وضع الصورة في الصورة',
  'Exit picture in picture mode': 'الخروج من وضع الصورة في الصورة',
  Play: 'تشغيل',
  Pause: 'إيقاف مؤقت',
  'Playback rate': 'سرعة التشغيل',
  'Playback rate {playbackRate}': 'سرعة التشغيل {playbackRate}',
  Quality: 'الجودة',
  'Seek backward': 'إرجاع',
  'Seek forward': 'تقديم',
  Settings: 'الإعدادات',
  Auto: 'تلقائي',
  'audio player': 'مشغل صوت',
  'video player': 'مشغل فيديو',
  volume: 'الصوت',
  seek: 'انتقال',
  'closed captions': 'الترجمة النصية',
  'current playback rate': 'سرعة التشغيل الحالية',
  'playback time': 'وقت التشغيل',
  'media loading': 'جاري التحميل',
  settings: 'الإعدادات',
  'audio tracks': 'مسارات الصوت',
  quality: 'الجودة',
  play: 'تشغيل',
  pause: 'إيقاف مؤقت',
  mute: 'كتم الصوت',
  unmute: 'إلغاء كتم الصوت',
  'chapter: {chapterName}': 'الفصل: {chapterName}',
  live: 'مباشر',
  Off: 'إيقاف',
  'start airplay': 'بدء AirPlay',
  'stop airplay': 'إيقاف AirPlay',
  'start casting': 'بدء البث',
  'stop casting': 'إيقاف البث',
  'enter fullscreen mode': 'دخول الشاشة الكاملة',
  'exit fullscreen mode': 'الخروج من الشاشة الكاملة',
  'enter picture in picture mode': 'دخول وضع الصورة في الصورة',
  'exit picture in picture mode': 'الخروج من وضع الصورة في الصورة',
  'seek to live': 'الانتقال إلى البث المباشر',
  'playing live': 'تشغيل مباشر',
  'seek back {seekOffset} seconds': 'إرجاع {seekOffset} ثانية',
  'seek forward {seekOffset} seconds': 'تقديم {seekOffset} ثانية',
  'Network Error': 'خطأ في الشبكة',
  'Decode Error': 'خطأ في فك التشفير',
  'Source Not Supported': 'المصدر غير مدعوم',
  'Encryption Error': 'خطأ في التشفير',
  'A network error caused the media download to fail.':
    'تسبب خطأ في الشبكة في فشل تنزيل الوسائط.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'تسبب خطأ في الوسائط في إيقاف التشغيل. قد تكون الوسائط تالفة أو متصفحك لا يدعم هذا التنسيق.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'حدث خطأ غير مدعوم. فشل الخادم أو الشبكة، أو متصفحك لا يدعم هذا التنسيق.',
  'The media is encrypted and there are no keys to decrypt it.':
    'الوسائط مشفرة ولا توجد مفاتيح لفك تشفيرها.',
};
